module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList14.e9c8e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList14.png
// module id = 7zX7
// module chunks = 0